import CaretToggle from './caret-toggle';

export default CaretToggle;